// @flow
import React from 'react'

import AbstractFormField from './AbstractFormField'
import Radio from './Radio'

import type { DefaultFormFieldState } from './AbstractFormField'
import type { ValidationErrorType } from '../../Types/ValidationError'

type BoolRadiosProps = {
  values: Array<Object>,
  domain: {},
  enabled?: boolean,
  id: string,
  isPristine?: boolean,
  label: string,
  name: string,
  onChange: (value: boolean) => void,
  textMode?: boolean,
  validationErrors: ValidationErrorType,
  value: boolean,
}

/**
 * Component for rendering radios with boolean values
 * @example ./docs/BoolRadios.md
 */
export default class BoolRadios extends AbstractFormField<BoolRadiosProps, DefaultFormFieldState> {
  static defaultProps = {
    enabled: true,
    isPristine: false,
    textMode: false,
  }

  handleOnChange = (value: Object) => {
    if (this.props.enabled) {
      this.props.onChange(value)
    }
  }

  render() {
    if (this.props.textMode) {
      for (let index = 0; index < this.props.values.length; index++) {
        if (this.props.values[index].value === this.props.value) {
          return <span>{this.props.values[index].label}</span>
        }
      }
      return null
    }

    const classes = []
    if (this.hasErrors() && !this.isPristine()) {
      classes.push('is-invalid')
    }

    return [
      <ul className="list list-in-row mb-0 child-mb-0 small-spacing w-100 pr-0" key={`radios-${this.props.id}`}>
        {this.props.values.map((option) => (
          <li className="py-2" key={`radios-${this.props.id}-${option.value}`}>
            <Radio
              checked={option.value === this.props.value}
              enabled={this.props.enabled}
              id={`radios-${this.props.id}-${option.label}`}
              label={option.label}
              name={`radios-${this.props.id}-${option.label}`}
              onChange={() => {
                this.handleOnChange(option.value)
              }}
              value={option.value}
            />
          </li>
        ))}
      </ul>,
      this.renderError(),
    ]
  }
}
